<template>
	<div class="menu-tile-bg" :class="`menu-tile-bg--${state}`">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 216 190"
			preserveAspectRatio="none"
		>
			<defs>
				<linearGradient
					v-if="state === MenuTileState.PREMIUM"
					:id="`linear-gradient-${MenuTileState.PREMIUM}`"
					x1="108"
					y1="186"
					x2="108"
					y2="4"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0" stop-color="#57236a" />
					<stop offset="1" stop-color="#a259be" />
				</linearGradient>

				<linearGradient
					v-if="state === MenuTileState.ACTIVE"
					xmlns="http://www.w3.org/2000/svg"
					:id="`linear-gradient-${MenuTileState.ACTIVE}`"
					x1="108"
					y1="186"
					x2="108"
					y2="4"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0" stop-color="#ab8849" />
					<stop offset="1" stop-color="#f2dcb5" />
				</linearGradient>

				<filter
					v-if="state === MenuTileState.BASE"
					id="luminosity-invert"
					x="1.66"
					y="1.07"
					width="213"
					height="187"
					color-interpolation-filters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feColorMatrix
						result="cm"
						values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
					/>
				</filter>

				<mask
					v-if="state === MenuTileState.BASE"
					id="mask"
					x="1.66"
					y="1.07"
					width="213"
					height="187"
					maskUnits="userSpaceOnUse"
				>
					<g class="cls-6">
						<image
							width="213"
							height="187"
							transform="translate(1.66 1.07)"
							xmlns:xlink="http://www.w3.org/1999/xlink"
							xlink:href="data:image/png;base64,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"
						/>
					</g>
				</mask>
			</defs>
			<g id="tile-center">
				<rect class="fill" x="4" y="4" width="208" height="182" />
				<g v-if="state === MenuTileState.BASE" class="fill-mask">
					<g class="fill-mask__inner">
						<rect
							class="fill-mask__inner-bg"
							x="4"
							y="4"
							width="208"
							height="182"
						/>
					</g>
				</g>
			</g>

			<g id="top-left">
				<path
					class="top-left"
					d="M4,186V4h208l3.62-3.17c-.36-.5-.95-.83-1.62-.83H2C.9,0,0,.9,0,2v186c0,.44.14.84.38,1.17l3.62-3.17h0Z"
				/>
			</g>
			<g id="bottom-right">
				<path
					class="bottom-right"
					d="M212,4v182H4l-3.62,3.17c.36.5.95.83,1.62.83h212c1.11,0,2-.89,2-2V2c0-.44-.14-.84-.38-1.17l-3.62,3.17Z"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts" setup>
import { MenuTileState } from "@/types/ui";

interface Props {
	state: MenuTileState;
}

const { state } = defineProps<Props>();
</script>

<style lang="scss" scoped>
.menu-tile-bg {
	svg {
		width: 100%;
		height: 100%;
	}

	&--base {
		.bottom-right {
			fill: #131217;
		}
		.top-left {
			fill: #5f6374;
		}
		.fill {
			fill: #191821;
		}
		.fill-mask {
			mask: url(#mask);

			&__inner {
				opacity: 0.5;

				&-bg {
					fill: #464a5d;
				}
			}
		}
	}

	&--premium {
		.bottom-right {
			fill: #221329;
		}
		.top-left {
			fill: #a679ba;
		}
		.fill {
			fill: url(#linear-gradient-premium);
		}
	}

	&--active {
		.bottom-right {
			fill: #65502b;
		}
		.top-left {
			fill: #f0dec1;
		}
		.fill {
			fill: url(#linear-gradient-active);
		}
	}

	// Textures
	&--base,
	&--premium,
	&--active {
		&::before {
			position: absolute;
			top: 0;
			left: 0;
			opacity: 0.6;
			width: 100%;
			height: 100%;
			content: "";
		}
	}

	&--base {
		&::before {
			@include background(
				url($path-backgrounds + "menu/tile-texture-base.avif"),
				cover,
				top center,
				no-repeat
			);
			opacity: 0.6;
		}
	}

	&--premium {
		&::before {
			@include background(
				url($path-backgrounds + "menu/tile-texture-base.avif"),
				cover,
				top center,
				no-repeat
			);
			opacity: 0.4;
		}
	}

	&--active {
		&::before {
			@include background(
				url($path-backgrounds + "menu/tile-texture-active.avif"),
				100%,
				bottom right,
				no-repeat
			);
			mix-blend-mode: multiply;
		}
	}

	&--royal-provision {
		&.menu-tile-bg {
			&--1,
			&--2,
			&--4,
			&--5,
			&--premium,
			&--active {
				&::before {
					position: absolute;
					top: 0;
					left: 0;
					opacity: 1;
					background-image: url($path-backgrounds + "menu/tile-sprite--royal-provision.avif?v2");
					// 6 sprite tiles = width 600%, height 100%
					background-size: 600% 100%;
					background-repeat: no-repeat;
					width: 100%;
					height: 100%;
					content: "";
				}

				svg {
					display: none;
				}
			}

			&--1 {
				&::before {
					background-position: 0% 0%; // 1
				}
			}

			&--2 {
				&::before {
					background-position: 20% 0%; // 2
				}
			}

			&--4 {
				&::before {
					background-position: 40% 0%; // 3
				}
			}

			&--5 {
				&::before {
					background-position: 60% 0%; // 4
				}
			}

			&--premium {
				&::before {
					background-position: 80% 0%; // 5
				}
			}

			&--active {
				&::before {
					background-position: 100% 0%; // 6
				}
			}
		}
	}
}
</style>
